import { ArrowRight } from "lucide-react";

const LegacyHighlightSection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      tag: "A Legacy of Excellence",
      title: "Awards, Recognition & The Culture That Defines Us",
      desc:
        "Consistent results, measurable impact, and a deep commitment to client trust.",

      box1: "Awards & Recognition",
      awards: [
        "Million Dollar Round Table (MDRT) Group Recognition — 2012 to 2025",
        "Million Dollar FYC Group — 2011 to 2025",
        "Pinnacle Club & Pinnacle Gold — 2002 to 2025",
        "High-Net-Worth Group Recognition — 2014–2017 and 2020–2025",
        "Over 3,000 client cases handled annually",
        "Assets under management exceeded S$11.7 million by 2024",
      ],

      box2: "The 5Cs That Define Us",
      cs: [
        {
          title: "Creativity",
          text: "We bring fresh thinking to every financial challenge.",
        },
        {
          title: "Charisma",
          text: "We connect authentically with every client and colleague.",
        },
        {
          title: "Competence",
          text: "We hold ourselves to the highest professional standards.",
        },
        {
          title: "Customer-Centricity",
          text: "Your needs are always at the centre of what we do.",
        },
        {
          title: "Commitment",
          text: "We are with you for the long journey, not just the first meeting.",
        },
      ],
    },

    zh: {
      tag: "卓越传承",
      title: "荣誉、认可与我们的文化",
      desc:
        "持续的成绩、真实的成果，以及对客户信任的坚定承诺。",

      box1: "荣誉与成就",
      awards: [
        "百万圆桌 MDRT 团队荣誉 — 2012 至 2025",
        "百万 FYC 团队 — 2011 至 2025",
        "Pinnacle Club & Pinnacle Gold — 2002 至 2025",
        "高净值团队荣誉 — 2014–2017 / 2020–2025",
        "每年处理超过 3000 个客户案例",
        "资产管理规模超过 S$11.7M",
      ],

      box2: "我们的 5C 文化",
      cs: [
        {
          title: "创造力",
          text: "以创新思维解决每一个财务问题。",
        },
        {
          title: "魅力",
          text: "真诚地与每一位客户建立联系。",
        },
        {
          title: "专业能力",
          text: "坚持最高的专业标准。",
        },
        {
          title: "以客户为中心",
          text: "客户需求始终放在第一位。",
        },
        {
          title: "承诺",
          text: "陪伴客户走过长期的财富旅程。",
        },
      ],
    },
  };

  return (
    <section className="bg-[#EBEBEB] py-10">
      <div className="max-w-[1320px] mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-10">

          <p className="uppercase text-[#C09F7C] font-bold tracking-wide mb-2">
            {text[lang].tag}
          </p>

          <h2 className="text-[34px] font-medium text-[#154059]">
            {text[lang].title}
          </h2>

          <p className="text-gray-700 mt-2 max-w-3xl mx-auto leading-relaxed">
            {text[lang].desc}
          </p>

        </div>


        <div className="grid md:grid-cols-2 gap-10">


          {/* BOX 1 */}
          <div className="bg-[#154059] p-10 shadow-md text-white
          transition-all duration-300 hover:shadow-xl hover:-translate-y-2">

            <h3 className="text-xl font-medium mb-6 text-[#C09F7C]">
              {text[lang].box1}
            </h3>

            <ul className="space-y-4 text-sm leading-relaxed">

              {text[lang].awards.map((item, index) => (

                <li key={index} className="flex items-start gap-3">

                  <ArrowRight size={16} className="mt-1 text-white" />

                  <span>{item}</span>

                </li>

              ))}

            </ul>

          </div>



          {/* BOX 2 */}
          <div className="bg-[#154059] p-10 shadow-md text-white
          transition-all duration-300 hover:shadow-xl hover:-translate-y-2">

            <h3 className="text-xl font-medium mb-6 text-[#C09F7C]">
              {text[lang].box2}
            </h3>

            <ul className="space-y-4 text-sm leading-relaxed">

              {text[lang].cs.map((item, index) => (

                <li key={index} className="flex items-start gap-3">

                  <ArrowRight size={16} className="mt-1 text-white" />

                  <span>
                    <span className="font-semibold">
                      {item.title}
                    </span>{" "}
                    — {item.text}
                  </span>

                </li>

              ))}

            </ul>

          </div>


        </div>
      </div>
    </section>
  );
};

export default LegacyHighlightSection;